module.exports = __webpack_public_path__ + "/images/shop/icon/wishlist_checked.svg";